import { render, staticRenderFns } from "./DiffBlameDeadlineDate.vue?vue&type=template&id=e19f1644&"
import script from "./DiffBlameDeadlineDate.vue?vue&type=script&lang=js&"
export * from "./DiffBlameDeadlineDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports